import React from 'react';
import WaterIntelQualityBadge from './WaterIntelQualityBadge';

type Props = { bathymetry?: any; isDarkMode: boolean };

const prettyStructure = (value: any) =>
  String(value || '')
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase());

const num = (...values: any[]) => {
  for (const value of values) {
    const n = Number(value);
    if (Number.isFinite(n)) return n;
  }
  return null;
};

export default function WaterIntelDepthPanel({ bathymetry, isDarkMode }: Props) {
  const available = !!bathymetry?.available;
  const depth = num(bathymetry?.depthMeters);
  const relief = num(bathymetry?.localReliefMeters, bathymetry?.reliefMeters);
  const slope = num(bathymetry?.slopeDeg);
  const slopeClass = String(bathymetry?.slopeClass || '').trim();
  const structures = Array.isArray(bathymetry?.structureTypes)
    ? bathymetry.structureTypes.filter(Boolean).slice(0, 2)
    : [];

  const primaryStructure = structures.length
    ? prettyStructure(structures[0])
    : (slopeClass ? prettyStructure(slopeClass) : '');

  const detail = [
    primaryStructure && primaryStructure !== 'Unknown' ? primaryStructure : '',
    relief == null ? '' : `${Math.round(relief)} m relief`,
    slope == null ? '' : `${slope.toFixed(1)}° slope`,
  ].filter(Boolean).join(' · ');

  return (
    <section
      className="min-w-0 rounded-[14px] border p-2.5 sm:rounded-[15px] sm:p-3"
      style={{
        background: isDarkMode ? 'rgba(11,23,39,0.88)' : 'rgba(255,255,255,0.68)',
        borderColor: isDarkMode ? 'rgba(124,199,255,0.12)' : 'rgba(69,127,157,0.10)',
      }}
    >
      <div className="flex items-center justify-between gap-2">
        <div
          className="text-[8px] font-black uppercase tracking-[0.14em]"
          style={{ color: isDarkMode ? '#7CC7FF' : '#356EAE' }}
        >
          Depth
        </div>
        <WaterIntelQualityBadge quality={bathymetry?.quality} isDarkMode={isDarkMode} />
      </div>

      {available ? (
        <>
          <div
            className="mt-1.5 text-[18px] font-black leading-none sm:text-[19px]"
            style={{ color: isDarkMode ? '#F2F6FC' : '#2D3957' }}
          >
            {depth == null ? '—' : `${Math.round(depth)} m`}
          </div>

          {primaryStructure ? (
            <div className="mt-1 truncate text-[10px] font-black opacity-80">{primaryStructure}</div>
          ) : null}

          {detail ? (
            <div className="mt-1 truncate text-[8.5px] font-bold opacity-50">{detail}</div>
          ) : null}
        </>
      ) : (
        <div
          className="mt-1.5 text-[11px] font-black leading-tight"
          style={{ color: isDarkMode ? '#AEB8C9' : '#756A60' }}
        >
          No coverage
        </div>
      )}
    </section>
  );
}
